import { getFilterSelectorsMk } from './filterSelectors';
import { getSeoDataMk } from './getSeoData';
import { getQsonJueryMk } from './jsonQuery';
import { getSearchItemMk } from './searchItem';
import { getCurrentSortVariantTypeMk, getSortVariantsMk } from './sortVariants';
import { getTagsMk } from './tags';
import { IFilterSelectorSchema } from '../../repositories/newbuilding-promos/entities/filter_selector/FilterSelectorSchema';
import { IPromoSearchItemSchema } from '../../repositories/newbuilding-promos/entities/promo_search_result/PromoSearchItemSchema';
import { ECurrentSortVariantType } from '../../repositories/newbuilding-promos/entities/search_promos/SearchPromosResponseSchema';
import { ISeoDataSchema } from '../../repositories/newbuilding-promos/entities/seo_data/SeoDataSchema';
import { ISortVariantSchema } from '../../repositories/newbuilding-promos/entities/sort_variant/SortVariantSchema';
import { ITagSchema } from '../../repositories/newbuilding-promos/entities/tag/TagSchema';
import { ISearchPromosResponse } from '../../repositories/newbuilding-promos/v1/search-promos';
import { mkBreadcrumbs } from '../mocks/breadcrumbs';

interface IProps {
  isCompilation?: boolean;
  seoData?: ISeoDataSchema;
  hasMore?: boolean;
  totalCountText?: string;
  totalPages?: number;
  queryString?: string;
  path?: string;
  currentSortVariantType?: ECurrentSortVariantType;
  filterSelectors?: IFilterSelectorSchema[];
  sortVariants?: ISortVariantSchema[];
  tags?: ITagSchema[];
  promos?: IPromoSearchItemSchema[];
}

// TODO: Заменить на респонс новой ручки в CD-203174
interface IResult extends ISearchPromosResponse {}

export const getSearchPromosResponseMk = (props: IProps): IResult => {
  const {
    isCompilation = false,
    hasMore = false,
    seoData = getSeoDataMk({}),
    totalCountText = 'Найдено: 128 предложений',
    totalPages = 120,
    queryString = 'is_from_bank=1',
    path = '/akcii-i-skidki/ipoteka/voennaya',
    currentSortVariantType = getCurrentSortVariantTypeMk(),
    filterSelectors = getFilterSelectorsMk(),
    sortVariants = getSortVariantsMk(),
    tags = getTagsMk(),
    promos = [
      getSearchItemMk({ uniquePromoId: '123' }),
      getSearchItemMk({ uniquePromoId: '124' }),
      getSearchItemMk({ uniquePromoId: '125' }),
    ],
  } = props;

  return {
    jsonQuery: getQsonJueryMk(),
    sortVariants,
    currentSortVariantType,
    queryString,
    path,
    filterSelectors,
    tags,
    breadcrumbs: mkBreadcrumbs(),
    seoData,
    subheader: 1,
    promoSearchResult: {
      hasMore,
      promos,
      totalCountText,
      // @ts-expect-error TODO: Убрать директиву в CD-203174
      totalPages,
    },
    isCompilation,
  };
};
